import { PropsWithChildren, FC, useState } from 'react'
import styles from '@OpsQuality/styles.css'
import { Modal } from 'antd'

import Box from '~/core/Box'
import ModelViewer from '~/core/ModelViewer'
import Button from '~/core/Button'
import { getReferencesOfJobRequestAttachments, isCompleted } from '../logic'

import PartsLayout from './components/PartsTab/PartsLayout'
import { adminJobRequestQuery_jobRequest as JobRequestType } from './__generated__/adminJobRequestQuery'
import { useJobRequestLinesByPart } from './components/logic'

interface PartsTabPropsType {
    jobRequest?: JobRequestType
}

const PartsTab: FC<PropsWithChildren<PartsTabPropsType>> = props => {
    const { jobRequest } = props
    const [isThreeDviewModalVisible, setThreeDviewModalVisible] =
        useState(false)
    const [sceneBundle, setSceneBundle] = useState(null)

    const isJobCompleted = jobRequest ? isCompleted(jobRequest) : false

    const jobRequestLinesByPart = useJobRequestLinesByPart(
        jobRequest?.parts || [],
    )
    const jobRequestLinesWithAttachmentRef =
        getReferencesOfJobRequestAttachments(jobRequestLinesByPart)

    const toggleModalFor3dViewer = (
        threeDviewModalVisible: boolean,
        sceneBundleData: any,
    ) => {
        setThreeDviewModalVisible(threeDviewModalVisible)
        setSceneBundle(sceneBundleData)
    }

    return (
        <Box flexWrap="wrap" className={styles.partsTab}>
            {jobRequest?.parts?.map(part => (
                <Box
                    direction="col"
                    key={part.id}
                    className={styles.cardLayoutPartWrapQC}
                >
                    <PartsLayout
                        partData={part}
                        jobRequestId={jobRequest?.id}
                        jobRequestName={jobRequest?.name}
                        toggleModalFor3dViewer={toggleModalFor3dViewer}
                        jobRequestLines={jobRequestLinesWithAttachmentRef}
                        isJobCompleted={isJobCompleted}
                    />
                </Box>
            ))}
            {isThreeDviewModalVisible && sceneBundle && (
                <Modal
                    title="3D Viewer"
                    className={styles.viewerModal}
                    bodyStyle={{
                        padding: 0,
                        position: 'relative',
                        marginBottom: '8px',
                    }}
                    width="95vw"
                    visible={isThreeDviewModalVisible}
                    onCancel={() => toggleModalFor3dViewer(false, sceneBundle)}
                    footer={
                        <Button
                            name="close-part-viewer-modal"
                            placement="order-detail-page"
                            data-test-target="close-part-viewer-modal-button"
                            onClick={() => {
                                toggleModalFor3dViewer(false, sceneBundle)
                            }}
                        >
                            Close 3D Viewer
                        </Button>
                    }
                >
                    <Box className={styles.modelViewerWrapper}>
                        <ModelViewer sceneBundle={sceneBundle} />
                    </Box>
                </Modal>
            )}
        </Box>
    )
}

export default PartsTab
